import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f921d14a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"display":"none"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("symbol", {
  id: "exclamation-triangle-fill",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger p-2 mt-1 mb-1 d-flex align-items-start sticky-top",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "bi flex-shrink-0 me-2",
    width: "24",
    height: "24",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#exclamation-triangle-fill" })
  ])
], -1))
const _hoisted_6 = { class: "ms-1 me-1 flex-grow-1" }
const _hoisted_7 = { key: 0 }

import { withDefaults } from 'vue';

interface Props {
  active: boolean;
  closeable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningModal',
  props: {
    active: { type: Boolean },
    closeable: { type: Boolean, default: true }
  },
  emits: ['reset'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3)),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (__props.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              (__props.closeable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      "aria-label": "Close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}
}

})